import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from "rxjs";
import { NGXLogger } from "ngx-logger";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { LatestToSShelterModel, ShelterService } from "../../service/shelter.service";
import { ShelterModel } from "../../models/shelter.model";
import { SharedLibraryService } from "../../../../../petszel-shared/src/lib/services/shared.config";
import * as _ from "lodash";
import { jwtDecode } from "jwt-decode";

@Component({
  selector: 'app-terms-of-service-modal',
  templateUrl: './terms-of-service-modal.component.html',
  styleUrls: ['./terms-of-service-modal.component.scss']
})
export class TermsOfServiceModalComponent implements OnInit, OnDestroy {
  @Input() latestToS!: LatestToSShelterModel;
  shelter!: ShelterModel | null;
  termsOfServiceURL: string = '';
  loading = false;

  private termsOfServiceSubs!: Subscription;
  private manageShelterSubs!: Subscription;

  constructor(private logger: NGXLogger,
              private shelterService: ShelterService,
              private activeModalService: NgbActiveModal,
              private sharedLibraryService: SharedLibraryService) {
  }

  ngOnInit(): void {
    this.shelterService.shelterObs$.subscribe(shelter => this.shelter = shelter);
    this.buildTOSUrl();
  }

  ngOnDestroy(): void {
    if (this.manageShelterSubs) { this.manageShelterSubs.unsubscribe(); }
    if (this.termsOfServiceSubs) { this.termsOfServiceSubs.unsubscribe(); }
  }

  acceptTerms(): void {
    this.loading = true;
    const decodedToken = jwtDecode<any>(localStorage.getItem('token') || '');
    const claimEmail = decodedToken['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'];

    const shelterData: ShelterModel = {
      ..._.cloneDeep(this.shelter) as ShelterModel,
      acceptedTerms: true,
      acceptedTermsVersion: this.latestToS.version,
      acceptedTermsVersionId: this.latestToS.id,
      acceptedTermsLastUser: claimEmail || 'Unknown User'
    };

    this.manageShelterSubs = this.shelterService.putAcceptTerms(shelterData).subscribe({
      next: () => {
        this.shelterService.getShelter().subscribe({
          next: () => {
            this.loading = false;
            this.activeModalService.close();
          },
          error: () => {
            location.reload();
          }
        })
      },
      error: err => {
        this.loading = false;
        this.logger.log('Error while accepting terms of service', err);
      }
    });

  }

  private buildTOSUrl(): void {
    const environment = this.sharedLibraryService.getSharedLibraryConfig().environmentType;
    if (environment === 'local' || environment === 'development') {
      this.termsOfServiceURL = 'https://dev.petszel.com/provider-terms-of-service';
    } else if (environment === 'beta') {
      this.termsOfServiceURL = 'https://beta.petszel.com/provider-terms-of-service';
    } else {
      this.termsOfServiceURL = 'https://petszel.com/provider-terms-of-service';
    }
  }
}
